import dayjs, { Dayjs } from "dayjs"
import { create } from "zustand"

import { ScheduledMessageWithRoutine } from "../../../types/scheduledMessages"

export enum ScheduledMessageModalView {
  ADD,
  EDIT,
  VIEW,
}

interface ScheduledMessageModalStore {
  isOpen: boolean
  onOpen: (data?: {
    scheduledMessage: ScheduledMessageWithRoutine
    timezone: string
  }) => void
  onClose: () => void

  scheduledMessageId: number | null

  message: string
  setMessage: (message: string) => void

  view: ScheduledMessageModalView
  setView: (view: ScheduledMessageModalView) => void

  error: string | null
  setError: (error: string) => void

  clientDatetime: Dayjs
  setClientDatetime: (datetime: Dayjs) => void

  attachment: File | null | undefined
  setAttachment: (attachment: File | null | undefined) => void
}

const initialData = {
  isOpen: false,
  view: ScheduledMessageModalView.ADD,
  scheduledMessageId: null,
  message: "",
  error: null,
  clientDatetime: dayjs().add(1, "day"),
  attachment: undefined,
}

const useScheduledMessageModalStore = create<ScheduledMessageModalStore>(
  (set) => ({
    ...initialData,

    onOpen: (data) => {
      const { scheduledMessage, timezone } = data || {}
      set({
        isOpen: true,
        view: scheduledMessage
          ? dayjs(scheduledMessage.datetime).isBefore(dayjs())
            ? ScheduledMessageModalView.VIEW
            : ScheduledMessageModalView.EDIT
          : ScheduledMessageModalView.ADD,
      })
      if (scheduledMessage) {
        set({
          scheduledMessageId: scheduledMessage.id,
          message: scheduledMessage.message,
          clientDatetime: dayjs(scheduledMessage.datetime).tz(timezone),
        })
      }
    },
    onClose: () => set(initialData),

    setMessage: (message) => set({ message }),
    setView: (view) => set({ view }),
    setClientDatetime: (datetime) => set({ clientDatetime: datetime }),
    setError: (error) => set({ error }),
    setAttachment: (attachment) => set({ attachment }),
  })
)

export default useScheduledMessageModalStore
